
    // TEXT input for "ProductOverview"
    const input = {
    // Product REVIEWS
    reviews: {
        href: 'https://www.google.com/',
        average: 4,
        totalCount: 117
    },

    // Product DESCRIPTIONS
    product: {
        // General Information about the product
        name: 'Cotton Tank Top',
        price: '$45',
        to: 'women/clothing/tops/nike3/Nike3',
        id: 'product-women-nike3',
        
        // Product Breadcrumbs
        breadcrumbs: [
            { id: 1, name: 'Women', to: '/women/clothing' },
            // { id: 2, name: 'Clothing', to:'/women/clothing'},
            // { id: 3, name: 'Tops', to: '/men/clothing/tops' },
        ],

        //Product Images
        images: [
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/women/12/product_women_7-1.jpg',
            alt: 'image 1',
            },
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/women/12/product_women_7-2.jpg',
            alt: 'image 2',
            },
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/women/12/product_women_7-3.jpg',
            alt: 'image 3',
            },
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/women/12/product_women_7-4.jpg',
            alt: 'image 4',
            },
        ],

        // Product Colors
        colors: [
            { name: 'White', class: 'bg-white', selectedClass: 'ring-gray-400' },
            { name: 'Gray', class: 'bg-gray-200', selectedClass: 'ring-gray-400' },
            { name: 'Black', class: 'bg-gray-900', selectedClass: 'ring-gray-900' },
        ],

        // Product Sizing
        sizes: [
            { name: '28', inStock: true },
            { name: '32', inStock: true },
            { name: '36', inStock: true },
            { name: '40', inStock: true },
            { name: '44', inStock: true },
            { name: '48', inStock: true },
            { name: '52', inStock: true },
            { name: '56', inStock: true },
        ],

        // Product Introduction
        description:
            "Our Cotton Tank Top is a must-have for everyday comfort. Made from soft, breathable cotton, it's perfect as a standalone piece on warm days or as a comfortable layering essential.",
        
        // Product Bulletpoints
        highlights: [
            'Ribbed collar',
            '100% cotton',
            'Machine wash',
        ],
        
        // Product Additional Information
        details:
            'Dropped shoulders, longer sleeves and a roomy fit through the body and hips give the Max90 tee a relaxed and casual look.',
    },

    // Personalized Recommendation per Product
    recommendation: [
        {
            id: 1,
            name: 'Basic Tee',
            category: "Men's T-Shirts",
            href: '/women/clothing/tops/nike1',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/women/1/product_women_1-1.jpeg',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$35',
            color: 'Black',
        },
        {
            id: 2,
            name: 'Basic Tee',
            category: "Men's T-Shirts",
            href: '/women/clothing/bottoms/zara1',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/women/2/product_women_2-1.jpeg',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$35',
            color: 'Black',
        },
        {
            id: 3,
            name: 'Basic Tee',
            category: "Men's T-Shirts",
            href: '/women/clothing/bottoms/zara2',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/women/3/product_women_3-1.jpg',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$35',
            color: 'Black',
        },
        {
            id: 4,
            name: 'Basic Tee',
            category: "Men's T-Shirts",
            href: '/women/clothing/tops/nike4',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/women/4/product_women_4-1.jpg',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$35',
            color: 'Black',
        },
        // More products...
    ]

    }

    export default input
    
